import React, { useEffect, useState } from 'react';
import SftGlobalData from '../../../library/SftGlobalData';
import { Button } from '@mui/material';
import Colors from '../../../library/Colors';
import axios from 'axios';
import crypto from 'crypto-js';
import PeppolDataTable from './PeppolDataTable'; // Import the new component

const PeppolModal = (props) =>  {  
    const [loading, setLoading] = useState(true);
    const [clientModId, setClientModId] = useState(props.mod.id);
    const [corpList, setCorpList] = useState([]);
    const [fetchedCorpList, setFetchedCorpList] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [apiRefCurrent, setApiRefCurrent] = useState(null);

    useEffect(() => {
        if(props.api){
            SftGlobalData.post('peppol&action=fetch', {key: props.api}).then(response => {
                setCorpList(response.data);
                setFetchedCorpList(response.data);
            }).catch(e => {
                console.log("Error", e);
            })
            .finally(() => {
                setLoading(false);
            });
        }
    }, [props.api]);

    const updateModule = (postData) => {
        SftGlobalData.post('client&action=updateModules', postData).then(response => {
            try{
                if(response.data.message === "success" && clientModId === null){
                    setClientModId(response.data.id);
                }
                props.onClose(response.data.id);
            }catch(e){
                
            }
        });
    }

    const checkOnVat = (vats, rowIds) => {
        let url = 'https://peppol.softtouch.eu/fetchByVat';
        const currentYear = new Date().getFullYear();
        const salt = `peppol-${currentYear}`;
        const hash = crypto.SHA256(`${SftGlobalData.peppol_password}${salt}`).toString(crypto.enc.Hex);

        let postBody = {
            "password": hash,
            "vatData": vats
        };

        if (SftGlobalData.debug) {
            console.log(` postBody:`, postBody);
        }
        
        axios.post(url, postBody, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(async response => {
            if (SftGlobalData.debug) {
                console.log('url', url);
                console.log('data', postBody);
                console.log('response', response.data);
            }
            // create a new array that adds the vat data to the rowIds
            const updatedRows = rowIds.map((id, index) => ({
                ...response.data.data[index],
                id: id
            }));

            // loop over updated row and add Peppol ID & Scheme to the corplist data for the row with the sameId using .map
            const updatedCorpList = corpList.map(row => {
                const updatedRow = updatedRows.find(updatedRow => updatedRow.id === row.id);
                return updatedRow
                    ? { ...row, peppol_id: updatedRow.customerReference, peppol_scheme: updatedRow.schemeId, updated: true }
                    : row;
            });
            
            if(SftGlobalData.debug){
                console.log(` updatedCorpList:`, updatedCorpList);
            }
            
            setCorpList(updatedCorpList);
        }).catch(error => {
            if (SftGlobalData.debug) {
                console.log('url', url);
                console.log('data', postBody);
                console.log('error', error);
            }
        });
    };

    const savePeppolInfo = () => {
        let postData = {key: props.api, data: corpList?.filter(x => x.updated)};
        SftGlobalData.post('peppol&action=save', postData).then(response => {
            setFetchedCorpList(response.data);
        }).catch(e => {
            console.log("Error", e);
        })
        .finally(() => {
            setLoading(false);
        });
    };

    const activatePeppol = () => {
        updateModule({key: props.api, database: props.database, mod_id: 61, client_mod_id: clientModId, user: props.username, sftUserId: props.userId});
    };
    
    const handleSelectionChange = (newSelection, apiRef) => {
        setSelectedRows(newSelection);
        setApiRefCurrent(apiRef.current);
    };

    return (
        <div style={{height: "100%", width: "100%", overflow: 'auto'}}>
            <h1>{props.t("peppol_modal_title")}</h1>
            <div style={{ width: '100%' }}>
                <div style={{ margin: "0.3rem",  display: 'flex', flexDirection: 'row', alignItems: 'center', alignContent: 'flex-start', justifyContent: 'flex-start', width: '100%'}} className='align_right'>
                    <Button
                        color="inherit"
                        variant="outlined"
                        sx={{
                        borderRadius: 3,
                        border: `2px solid ${Colors.sft_blue}`,
                        color: Colors.sft_blue,
                        margin: '0.3rem'
                        }}
                        disabled={selectedRows.length === 0}
                        onClick={() => {
                            if (apiRefCurrent) {
                                const selectedIds = apiRefCurrent.getSelectedRows();
                                const selectedRows = corpList.filter(row => selectedIds.has(row.id));
                                checkOnVat(selectedRows.map(row => row.vat), selectedRows.map(row => row.id));
                            }
                        }}
                    >
                        {props.t('peppol_fetch_all_by_vat')}
                    </Button>
                </div>
                
                {/* Use the flexible PeppolDataTable component */}
                <PeppolDataTable 
                    data={corpList}
                    loading={loading}
                    theme={props.theme}
                    checkboxSelection={true}
                    showCheckVatAction={true}
                    checkOnVat={checkOnVat}
                    onSelectionChange={handleSelectionChange}
                />
                
                <div style={{ margin: "0.3rem",  display: 'flex', flexDirection: 'row', alignItems: 'center', alignContent: 'flex-start', justifyContent: 'flex-end', width: '100%'}} className='align_right'>
                    <Button
                        color="inherit"
                        variant="outlined"
                        sx={{
                        borderRadius: 3,
                        border: `2px solid ${Colors.sft_blue}`,
                        color: Colors.sft_blue,
                         margin: '0.3rem'
                        }}
                        disabled={corpList.filter(row => row.updated).length === 0}
                        onClick={savePeppolInfo}
                    >
                        {props.t('peppol_save_info')}
                    </Button>
                    <Button
                        color="inherit"
                        variant="outlined"
                        sx={{
                        borderRadius: 3,
                        border: `2px solid ${Colors.sft_blue}`,
                        color: Colors.sft_blue,
                         margin: '0.3rem'
                        }}
                        disabled={fetchedCorpList.filter(row => row.peppol_supplier_id).length === 0}
                        onClick={activatePeppol}
                    >
                        {props.t('peppol_activate')}
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default PeppolModal;